import { render, staticRenderFns } from "./Abstract.vue?vue&type=template&id=23253b5e&scoped=true&"
import script from "./Abstract.vue?vue&type=script&lang=js&"
export * from "./Abstract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23253b5e",
  null
  
)

export default component.exports